export default "__VITE_ASSET__fp1R13Cq__"